import { Observable } from 'rxjs';
import { TransportDamageRequest } from '../../model/transport-damage.model';

export abstract class TransportDamageAdapter {
  abstract adviseOfTransportDamage(
    request: TransportDamageRequest
  ): Observable<void>;
}
